//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios, { CancelToken } from "axios";

export default {
  data() {
    return {
      datalist: [
        {
          BU: "",
          MC_TYPE: "",
          OUTPUT_PER: 0,
          OUTPUT_SP: 0,
          REC_TYPE: "edit",
          ROWID: "",
          TABLE_GM: 0,
          TEAM: 0,
          TIME_MIN: 0,
          WORKER: 0,
          WORKER_SP: 0,
          WORK_DATE: 0,
          WORK_DATE1: "",
          index: 0,
          selected: false
        }
      ],
      pagination: {
        rowsPerPage: 0 // current rows per page being displayed
      },
      fixed: false,
      fixed2: false,
      workdate: "",
      workdate1: "",
      mctype: null,
      team: null,
      table_gm: null,
      worker: null,

      worker_sp: null,
      timeminute: null,
      output: null,
      output_sp: null,
      date: "",
      DialogDelete: false,
      v1: "",
      v2: "",
      v3: "",
      v4: "",

      selected: [],

      columns: [
        {
          name: "WORK_DATE1",
          field: "WORK_DATE1",
          required: true,
          label: "Work Date",
          align: "left",
          sortable: true
        },
        {
          name: "BU",
          align: "left",
          field: "BU",
          label: "Loc",
          sortable: true
        },
        {
          name: "MC_TYPE",
          align: "left",
          field: "MC_TYPE",
          label: "MC Type",
          sortable: true
        },
        {
          name: "TEAM",
          align: "left",
          field: "TEAM",
          label: "Team",
          sortable: true
        },
        {
          name: "TABLE_GM",
          align: "left",
          field: "TABLE_GM",
          label: "Table",
          sortable: true
        },
        {
          name: "WORKER",
          align: "left",
          field: "WORKER",
          label: "Worker Cut",
          sortable: true
        },
        {
          name: "WORKER_SP",
          align: "left",
          field: "WORKER_SP",
          label: "Woker Sp",
          sortable: true
        },
        
        {
          name: "OUTPUT_PER",
          align: "left",
          field: "OUTPUT_PER",
          label: "Ouput Cut",
          sortable: true
        },
        {
          name: "OUTPUT_SP",
          align: "left",
          field: "OUTPUT_SP",
          label: "Ouput Sp",
          sortable: true
        },
        {
          name: "TIME_MIN",
          field: "TIME_MIN",
          align: "left",
          label: "Time Minutes",
          sortable: true
        },
        { name: "ACTION", align: "left", label: "Action" }
      ]
    };
  },

  async mounted() {
    await this.curdate();
    await this.LoadData();
   
    // grp: this.$route.params.grp
  },
  methods: {
    async curdate() {
      let res = await axios.post(`${this.$apiflask}/curdate`);
      this.date = res.data.dte;
    },

    // console.log(res.data);

    LoadData() {
      
      const obj = axios({
        method: "post",
        url: `${this.$apiflask}nygctroom/setup/dailycut/view`, // php performance_nyg.py
        data: { loc: this.$route.params.loc, dte: this.date}
        
      }).then(res => {
        // console.log(data)
        this.selected = [];
        // console.log(res.data);
        // console.log("res.data", res.data);
        //this.datalist = res.data.data;
        this.datalist = res.data.data.map(item => {
          //var No = index + 1;
          var selected = false;
          return { ...item, selected };
        });
        // console.log("datalist", this.datalist);
      });
    },
    // checkAll(e) {
    //   console.log("e", e);

    //   this.datalist.forEach(element => {
    //     element.selected = e;
    //   });

    //   console.log("datalist", this.datalist);
    // },
    // checkThis(e) {
    //   console.log("checkThis", e);
    // },
    
    LoadCutspeed() {
      const obj = 
      axios({
        method: "post",
        url: `${this.$apiflask}/nygctroom/dailycut/readcutspeed`,
        data: {loc: this.$route.params.loc},
      }).then((res) => {
        // console.log(res.data.data[0]);
        this.output = res.data.mtrs_min;
        this.output_sp = res.data.sp_min;
      });
    },

    DialogAdd() {
      this.fixed = true;
      this.workdate = this.date;
    },

    DialogCopy() {
      // console.log( this.selected)
      if (this.selected.length === 0) {
        this.Noti("Select Item!");
        return false;
      }
      this.fixed2 = true;
      this.workdate1 = this.date;

      // console.log("datalist", this.datalist);
      // var SelectArray = this.datalist.filter(function(item) {
      //   return item.selected === true;
      // });
      // console.log("SelectArray", SelectArray);
      // console.log(this.selected);  v1, v2, v3, v4, v5, v6, v7, v8, v9
    },
      // Updata(v1, v2, v3,v4,v5,v6,v7,v8,v9) {
      // this.v1 = v1;
      // this.v2 = v2;
      // this.v3 = v3;
      // this.v4 = v4;
      // this.v5 = v5;
      // this.v6 = v6;
      // this.v7 = v7;
      // this.v8 = v8;
      // this.v9 = v9;
      // this.UpdataData(v1, v2, v3,v4,v5,v6,v7,v8,v9);
      // },
    ShowDialogDelete(v1, v2, v3, v4) {
      this.DialogDelete = true;
      this.v1 = v1;
      this.v2 = v2;
      this.v3 = v3;
      this.v4 = v4;
   
    },
    Insert() {
      if (this.workdate == null) {
        this.Noti("Work Date!");
        return false;
      }
      if (this.mctype == null) {
        this.Noti("MC Type!");
        return false;
      }
      if (this.team == null) {
        this.Noti("Team!");
        return false;
      }
      if (this.table_gm == null) {
        this.Noti("Table_GM!");
        return false;
      }
      if (this.worker == null) {
        this.Noti("Worker!");
        return false;
      }
      if (this.worker_sp == null) {
        this.Noti("Worker!");
        return false;
      }
      if (this.timeminute == null) {
        this.Noti("Time Minutes!");
        return false;
      }
      if (this.output == null) {
        this.Noti("Output!");
        return false;
      }
      if (this.output_sp == null) {
        this.Noti("Output!");
        return false;
      }

      this.InsertData();
    },
    Noti(txt) {
      this.$q.notify({
        position: "top-right",
        timeout: 1500,
        textColor: "white",
        color: "red",
        message: `Require ${txt}`,
        html: true
      });
    },
 

    UpdataData(v1,v2,v3,v4,v5,v6,v7,v8,v9) {
      const obj = axios({
        method: "post",
        url: `${this.$apiflask}/nygctroom/setup/dailycut/update`, // php performance_nyg.py
        data: {
          dte: v1,
          loc: this.$route.params.loc,
          mctype: v2,
          team: v3,
          table_gm: v4,
          worker: v5,
          worker_sp: v6,
          output: v7,
          output_sp: v8,
          timemin: v9
          
        }
      }).then(res => {
        if (res.data.success == true) {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "green",
            message: "Save Success",
            html: true
          });
          this.LoadData();
        } else {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "red",
            message: "Save Fail!",
            html: true
          });
        }
      });
    },
    DeleteData() {
      const obj = axios({
        method: "post",
        url: `${this.$apiflask}/nygctroom/setup/dailycut/delete`, // php performance_nyg.py
        data: {
          dte: this.v1,
          loc: this.$route.params.loc,
          mctype: this.v2,
          team: this.v3,
          table_gm: this.v4
        }
      }).then(res => {
        if (res.data.success == true) {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "green",
            message: "Save Success",
            html: true
          });
          this.DialogDelete = false
          this.LoadData();
        } else {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "red",
            message: "Save Fail!",
            html: true
          });
        }
      });
    },
    InsertData() {
      const obj = axios({
        method: "post",
        url: `${this.$apiflask}/nygctroom/setup/dailycut/insert`, // php performance_nyg.py
        data: {
          loc: this.$route.params.loc,
          dte: this.workdate,
          mctype: this.mctype,
          team: this.team,
          worker: this.worker,
          worker_sp: this.worker_sp,
          timemin: this.timeminute,
          output: this.output,
          output_sp: this.output_sp,
          table_gm: this.table_gm
        }
      }).then(res => {
        if (res.data.success == true) {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "green",
            message: "Save Success",
            html: true
          });
          this.LoadData();
        } else {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "red",
            message: "Save Fail!",
            html: true
          });
        }
      });
    },
    Copy() {
      if (this.workdate1 == null) {
        this.Noti("Work Date!");
        return false;
      }
      this.InsertCopyData();
    },

    InsertCopyData() {
      // console.log(this.selected);
      const obj = axios({
        method: "post",
        url: `${this.$apiflask}/nygctroom/setup/dailycut/Copy`, // php performance_nyg.py
        data: {
          selected: this.selected,
          dte: this.workdate1
        }
      }).then(res => {
        if (res.data.success == true) {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "green",
            message: "Save Success",
            html: true
          });
          this.fixed2 = false
          this.LoadData();
        } else {
          this.$q.notify({
            position: "top-right",
            timeout: 1500,
            textColor: "white",
            color: "red",
            message: "Save Fail!",
            html: true
          });
        }
      });
    }
  },

  watch: {
    mctype: function(newValue, oldValue) {
      console.log(newValue)
      if(newValue === "MANUAL"){
        this.output = 0.9 
        this.output_sp = ""
      }
      else if(newValue == "AUTO"){
        this.LoadCutspeed();
      }
    }
    
  }
};


